import logger from '@utils/logger';
import { useCreateCategoryMutation } from 'src/graphql/generated/graphql';

const useCreateCategory = () => {
  const { mutate, mutateAsync, isError, isLoading, isSuccess, data } = useCreateCategoryMutation({
    onError: (error) => {
      let loggedError: Error = Error('createCategory failed');
      if (error instanceof Error) {
        loggedError = error;
      }
      void logger.error('Call to createCategory resulted in error', loggedError);
    },
    onSuccess: (response) => {
      const { error } = response.createCategory;
      if (error) {
        void logger.error('Call to createCategory resulted in error', error);
      } else {
        void logger.info('Successfully created category');
      }
    },
  });

  const { error } = data?.createCategory ?? {};
  return {
    mutate,
    mutateAsync,
    isError,
    isLoading,
    isSuccess,
    error,
    data: data?.createCategory.category,
  };
};

export default useCreateCategory;
